export const TRUE_STATUS = 'TRUE_STATUS';
export const FALSE_STATUS = 'FALSE_STATUS';

export const trueStatus = () => ({ type: TRUE_STATUS });
export const falseStatus = () => ({ type: FALSE_STATUS });